
import AssetSummary from '@components/AssetSummary.vue';
import Video from '@structure/Resources/Video';
import { serviceUrl } from '@/support';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      cacheToken: Math.random().toString(36).slice(2),
    };
  },

  computed: {
    ...mapGetters(['currentResource']),

    // Naively pull the extension from the file's basename. 'test.mmm.mp4' => 'mp4'
    extension(): string {
      return this.currentResource.basename().replace(/^.+\.([^\.]+)$/, '$1');
    },

    pathname(): string {
      return this.currentResource.path();
    },

    /**
     * If the aspect ratio of the video matches a 540 x 960 resolution, lets wrap
     * the video tag in a wireframe of an iPhone so the client can see it in context.
     */
    looksLikePhonePortrait() {
      return this.currentResource.shouldShowFrame();
    },

    source(): string {
      let url;

      url = serviceUrl(['raw', 'content', this.currentResource.path()]);

      url.searchParams.append('c', this.cacheToken);

      return url.toString();
    },

    styles() {
      return {
        maxWidth: `${this.currentResource.width()}px`,
        maxHeight: `${this.currentResource.height()}px`,
      };
    },
  },
  components: {
    AssetSummary,
  },
};
